import Glide from '@glidejs/glide';

export default function (el) {
  console.log(el);
  if (!el) return;

  const glide = new Glide(el, {
    type: 'carousel',
  });

  glide.mount();
}
